/** Angular */
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
/** Sixense */
import { DsLibLanguageService } from '@sixense/ds-lib-common';
/** Services */
import { AuthService } from '@core/auth/auth.service';
import { DsLogosInterface } from '@sixense/ds-lib-login-form/lib/interfaces/ds-logos.interface';
/** Constants */
import { PRODUCT_NAME } from '@core/constants/product-name.constant';
import { LOGIN_LOGS } from './constants/login-logs.constant';

@Component({
  selector: 'ds-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  /**
   *
   */
  language = 'en';

  /**
   * The header & footer logos paths.
   */
  public logos: DsLogosInterface = LOGIN_LOGS;

  /**
   * Name displayed at the bottom of login page.
   */
  public productName = PRODUCT_NAME;

  /**
   * Creates an instance of LoginComponent.
   *
   * @param router ngModule that provides navigation and URL manipulation
   * @param activatedRoute the activated route
   * @param languageService languageService
   * @param authService authService
   */
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private languageService: DsLibLanguageService,
    private authService: AuthService
  ) {
    /** Load the last used language inside the app or browser language if no previous data is found */
    this.languageService.useLoginLang();
    this.languageService.setStoredLanguage(this.languageService.getCurrentLang());
    this.language = this.languageService.getCurrentLang();
  }

  /**
   * Navigate to the main page.
   */
  loginSuccess(): void {
    this.router.navigate(['main'], {
      queryParamsHandling: 'preserve',
    });
    this.authService.updateLatestAccount();
  }

  /**
   * Update current language.
   *
   * @param language current language
   */
  updateLanguage(language: string): void {
    this.languageService.use(language);
    this.languageService.setPickedLanguage(language);
  }
}
